var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconRefinancingCalculatorActive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1)",
    stroke: "#10C98F",
    strokeWidth: 1.5,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.333,
    cy: 15.625,
    rx: 2.667,
    ry: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 19.375c5.155 0 9.333-3.918 9.333-8.75S15.155 1.875 10 1.875c-3.515 0-6.437 2.051-8 5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 .625v6.25h6.667"
  }))));
}
export default SvgIconRefinancingCalculatorActive;